module.exports = __webpack_public_path__ + "img/BRK.a6181fc3.svg";